export const getSelectionText = () => {
  if (window.getSelection) {
    try {
      var activeElement = document.activeElement;
      if (activeElement && activeElement.value) {
        // firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=85686
        return activeElement.value.substring(activeElement.selectionStart, activeElement.selectionEnd);
      } else {
        return window.getSelection().toString();
      }
    } catch (e) {}
  } else if (document.selection && document.selection.type !== 'Control') {
    // For IE
    return document.selection.createRange().text;
  }
};
